import { useState, useCallback, useEffect, createContext } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import About from "./components/About";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Header from "./components/Header";
import Landing from "./components/Landing";

export const WindowWidthContext = createContext();

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const resizeEvent = useCallback(() => {
    setWindowWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", resizeEvent);

    return () => window.removeEventListener("resize", resizeEvent);
  }, [resizeEvent]);

  return (
    <Router className="App">
      <WindowWidthContext.Provider value={windowWidth}>
        <Header />
        <Switch>
          <Route component={Gallery} path="/gallery" />
          <Route path="/about">
            <About />
            <Footer />
          </Route>
          <Route component={Landing} path="/" />
        </Switch>
      </WindowWidthContext.Provider>
    </Router>
  );
}

export default App;
